//Don't import anything.  This file is used by gulp to generate the css and it must be valid node code

/**
 * These will be rendered in the epic games logo dropdown in the order of these keys.
 * The objects hold very important default data. Be careful when editing.
 *
 * sassFile -> array consisting of extact filenames (no extension) which matches with the custom property styles in /styles/properties
 * egName -> The default text to show in the Epic shield dropdown for the property
 * egHref -> The default href value of the anchor in the Epic shield dropdown for the property
 * defaultProduction Links -> the default array of links just in case CMS data fails or 'links' isn't passed
 */
const properties = {
    epic_games: {
        sassFile: ['epic_games'],
        egName: 'Epic Games',
        egHref: 'https://www.epicgames.com'
    },

    unreal_engine: {
        sassFile: ['unreal_engine'],
        egName: 'Unreal Engine',
        egHref: 'https://www.unrealengine.com'
    },

    paragon: {
        sassFile: ['paragon'],
        egName: 'Paragon',
        egHref: 'https://www.epicgames.com/paragon'
    },

    odin: {
        sassFile: ['odin'],
        egName: 'Robo Recall',
        egHref: 'https://www.epicgames.com/roborecall'
    },

    unreal_tournament: {
        sassFile: ['unreal_tournament'],
        egName: 'Unreal Tournament',
        egHref: 'https://www.epicgames.com/unrealtournament'
    },

    fortnite: {
        sassFile: ['fortnite'],
        egName: 'Fortnite',
        egHref: 'https://www.epicgames.com/fortnite'
    },

    spy_jinx: {
        sassFile: ['spy_jinx'],
        egName: 'SpyJinx',
        egHref: 'https://www.epicgames.com/spyjinx'
    },

    shadow_complex: {
        sassFile: ['shadow_complex'],
        egName: 'Shadow Complex',
        egHref: 'https://www.epicgames.com/shadowcomplex'
    },

    battle_breakers: {
        sassFile: ['battle_breakers'],
        egName: 'Battle Breakers',
        egHref: 'https://www.epicgames.com/battlebreakers'
    },

    infinity_blade: {
        sassFile: [],
        egName: 'Infinity Blade',
        egHref: 'https://www.epicgames.com/infinityblade'
    }
};

/*eslint-disable */
//node.js doesn't support some of the es6 stuff
//
//allow the window._epicGamesNav.properties to override the settings for egName, egHref, egSkip, and egDisabled
if (typeof window !== 'undefined' && window._epicGamesNav && window._epicGamesNav.properties) {
    for (var i = 0; i < window._epicGamesNav.properties.length; i++) {
        var property = window._epicGamesNav.properties[i];
        if (property && typeof property === 'string') {
            if (window._epicGamesNav.properties[property].egName) {
                properties[property.propertyKey].egName = property.egName;
            }
            if (window._epicGamesNav.properties[property].egHref) {
                properties[property.propertyKey].egHref = property.egHref;
            }
            if (window._epicGamesNav.properties[property].egDisabled !== undefined) {
                properties[property.propertyKey].egDisabled = property.egDisabled;
            }
            if (window._epicGamesNav.properties[property].egSkip !== undefined) {
                properties[property.propertyKey].egSkip = property.egSkip;
            }
        }
    }
}

/*eslint-enable */

module.exports = properties;



// WEBPACK FOOTER //
// ../epic-games-nav/app/scripts/constants/properties.js